<div class="rc-page">
  <!-- LEFT: form panel -->
  <aside class="rc-sidebar">
    <form class="rc-form" (ngSubmit)="evaluate()">
      <h2 class="rc-form__title">Evaluate</h2>

      <div class="rc-field">
        <label for="rc-id">Packaging unit ID</label>
        <input id="rc-id" type="number" name="id" [(ngModel)]="id" required />
      </div>
      <div class="rc-field">
        <label for="rc-version">Version</label>
        <input id="rc-version" type="number" name="version" [(ngModel)]="version" required />
      </div>

      <button type="submit" class="rc-btn rc-btn--primary" [disabled]="loading() || id == null || version == null">
        {{ loading() ? 'Evaluating…' : 'Evaluate' }}
      </button>
      <button type="button" class="rc-btn rc-btn--secondary" (click)="testWithMockData()">Test Mock</button>
    </form>

    <p class="rc-sidebar__error" *ngIf="error()">{{ error() }}</p>

    <div class="rc-tally" role="list" aria-label="Rating distribution" *ngIf="packagingUnit && evaluation && !loading()">
      <span class="rc-chip rc-chip--green" role="listitem"><span class="rc-dot rc-dot--sm" data-rating="GREEN"></span> {{ ratingTally().GREEN }} recyclable</span>
      <span class="rc-chip rc-chip--yellow" role="listitem"><span class="rc-dot rc-dot--sm" data-rating="YELLOW"></span> {{ ratingTally().YELLOW }} limited</span>
      <span class="rc-chip rc-chip--red" role="listitem"><span class="rc-dot rc-dot--sm" data-rating="RED"></span> {{ ratingTally().RED }} not recyclable</span>
      <span class="rc-chip rc-chip--unknown" role="listitem"><span class="rc-dot rc-dot--sm" data-rating="UNKNOWN"></span> {{ ratingTally().UNKNOWN }} unknown</span>
    </div>
  </aside>

  <!-- RIGHT: results -->
  <main class="rc-main">
    <div class="rc-empty rc-empty--placeholder" *ngIf="!packagingUnit || !evaluation || loading()">
      <span *ngIf="loading()">Evaluating…</span>
      <span *ngIf="!loading() && (!packagingUnit || !evaluation)">Enter an ID and click Evaluate to see results.</span>
    </div>

    <section class="rc" *ngIf="packagingUnit && evaluation && !loading()">
      <!-- Header -->
      <header class="rc-head">
        <div>
          <p class="rc-eyebrow">Recyclability · {{ packagingUnit.assemblyCountry }}</p>
          <h1 class="rc-title">{{ packagingUnit.productName }}</h1>
          <p class="rc-sub">{{ packagingUnit.brandName }} · {{ packagingUnit.packagingTypeName }} · v{{ packagingUnit.version }}</p>
        </div>
      </header>

      <!-- Sorting fractions with per-fraction log -->
      <h2 class="rc-section-h">Sorting fractions</h2>
      <ul class="rc-fractions">
        <li class="rc-fraction" *ngFor="let f of fractions(); trackBy: trackByFraction">
          <h3 class="rc-fraction__name">
            {{ f.name }}
            <span *ngFor="let d of allDisclaimersForFraction(f)" class="rc-disclaimer" [title]="disclaimerTooltip(d)">{{ disclaimerLabel(d) }}</span>
          </h3>
          <ul class="rc-fraction__items">
            <li class="rc-fraction__item" *ngFor="let c of componentsForFraction(f); trackBy: trackByGuid">
              <ng-container [ngSwitch]="c.groupName">
                <img *ngSwitchCase="'Main Body'"     class="rc-fraction__cat-icon" src="/assets/images/elements/component_types/main_body_types/bottle.svg" />
                <img *ngSwitchCase="'Closure'"       class="rc-fraction__cat-icon" src="/assets/images/elements/component_types/closure.svg" />
                <img *ngSwitchCase="'Label'"         class="rc-fraction__cat-icon" src="/assets/images/elements/component_types/decoration.svg" />
                <img *ngSwitchCase="'Sleeve'"        class="rc-fraction__cat-icon" src="/assets/images/elements/component_types/decoration.svg" />
                <img *ngSwitchCase="'Inlay'"         class="rc-fraction__cat-icon" src="/assets/images/elements/component_types/inlay_dark.svg" />
                <img *ngSwitchCase="'In-Mold Label'" class="rc-fraction__cat-icon" src="/assets/images/elements/component_types/decoration.svg" />
                <img *ngSwitchCase="'Packaging Aid'" class="rc-fraction__cat-icon" src="/assets/images/elements/component_types/packagingAid.svg" />
                <img *ngSwitchDefault                class="rc-fraction__cat-icon" src="/assets/images/elements/component_types/main_body_types/bottle.svg" />
              </ng-container>
              <span class="rc-fraction__kind">{{ c.groupName }}</span>
              <span class="rc-fraction__sub">{{ c.subtypeName }}</span>
            </li>
          </ul>

          <!-- Per-fraction log -->
          <div class="rc-log rc-log--fraction" style="margin-top: 14px" *ngIf="logMessagesForFraction(f).length > 0">
            <button class="rc-log__toggle" type="button" (click)="toggleLogForFraction(f.id)" [attr.aria-expanded]="isLogExpandedForFraction(f.id)">
              <span class="rc-log__toggle-label">{{ isLogExpandedForFraction(f.id) ? 'Hide' : 'Show' }} log ({{ logMessagesForFraction(f).length }} messages)</span>
              <span class="rc-log__arrow" [class.rc-log__arrow--open]="isLogExpandedForFraction(f.id)">▾</span>
            </button>
            <div class="rc-log__body" *ngIf="isLogExpandedForFraction(f.id)">
              <div class="rc-log__filters">
                <button *ngFor="let lvl of logLevels" type="button" class="rc-log__filter-btn"
                  [class.rc-log__filter-btn--active]="isLogLevelActive(lvl)"
                  [attr.data-level]="lvl"
                  (click)="toggleLogLevel(lvl)">{{ lvl }}</button>
              </div>
              <ul class="rc-log__list">
                <li *ngFor="let m of filteredLogMessagesForFraction(f)" class="rc-log__entry" [attr.data-level]="m.logLevel">
                  <span class="rc-log__level" [attr.data-level]="m.logLevel">{{ m.logLevel }}</span>
                  <span class="rc-log__msg">
                    <ng-container *ngFor="let part of resolveGuids(m.content)">
                      <strong *ngIf="part.isGuid && part.isKnown" [title]="part.guid">{{ part.text }}</strong>
                      <span *ngIf="part.isGuid && !part.isKnown" class="rc-log__guid" [title]="part.guid">{{ part.text }}</span>
                      <ng-container *ngIf="!part.isGuid">{{ part.text }}</ng-container>
                    </ng-container>
                  </span>
                </li>
                <li class="rc-log__empty" *ngIf="!filteredLogMessagesForFraction(f).length">No messages for the selected log levels.</li>
              </ul>
            </div>
          </div>
        </li>
        <li class="rc-empty" *ngIf="!fractions().length">No sorting fraction was assigned in this evaluation.</li>
      </ul>

      <!-- Components & materials -->
      <h2 class="rc-section-h">Components &amp; materials</h2>
      <ul class="rc-groups">
        <li class="rc-group" *ngFor="let c of components(); trackBy: trackByGuid">
          <div class="rc-group__body">
            <div class="rc-group__head">
              <div>
                <span class="rc-group__kind">{{ c.groupName }}</span>
                <h3 class="rc-group__name">
                  {{ c.subtypeName }}
                  <span class="rc-group__article" *ngIf="c.articleName">· {{ c.articleName }}</span>
                </h3>
                <span class="rc-group__guid" [title]="c.guid">{{ c.guid }}</span>
              </div>
              <div class="rc-group__meta">
                <span class="rc-group__weight">{{ c.totalWeight }} g</span>
                <span class="rc-rigid" *ngIf="c.isRigid !== null">{{ c.isRigid ? 'rigid' : 'flexible' }}</span>
              </div>
            </div>

            <table class="rc-layers">
              <thead>
                <tr>
                  <th scope="col">Material</th>
                  <th scope="col">Function</th>
                  <th scope="col">Color</th>
                  <th scope="col" class="rc-num">Mass</th>
                  <th scope="col">Rating</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let l of c.layers; trackBy: trackByGuid">
                  <td>
                    <span class="rc-mat">{{ l.materialName }}</span>
                    <span class="rc-mat__man" *ngIf="l.manifestationName !== l.materialName">{{ l.manifestationName }}</span>
                  </td>
                  <td class="rc-muted">{{ l.functionName }}</td>
                  <td class="rc-muted">{{ l.color || '—' }}</td>
                  <td class="rc-num">{{ l.mass }} g</td>
                  <td>
                    <span class="rc-rating" [attr.data-rating]="l.rating">
                      <span class="rc-dot" [attr.data-rating]="l.rating"></span>
                      {{ ratingLabel(l.rating) }}
                      <span class="rc-pct" *ngIf="l.ratingPercentage < 100">{{ l.ratingPercentage }}%</span>
                    </span>
                    <span *ngFor="let d of l.disclaimers" class="rc-disclaimer" [title]="disclaimerTooltip(d)">{{ disclaimerLabel(d) }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </li>
      </ul>

      <!-- Global evaluation log -->
      <h2 class="rc-section-h">Evaluation log</h2>
      <div class="rc-log">
        <button class="rc-log__toggle" type="button" (click)="logExpanded['__global'] = !logExpanded['__global']" [attr.aria-expanded]="logExpanded['__global']">
          <span class="rc-log__toggle-label">{{ logExpanded['__global'] ? 'Hide' : 'Show' }} log ({{ logMessages().length }} messages)</span>
          <span class="rc-log__arrow" [class.rc-log__arrow--open]="logExpanded['__global']">▾</span>
        </button>
        <div class="rc-log__body" *ngIf="logExpanded['__global']">
          <div class="rc-log__filters">
            <button *ngFor="let lvl of logLevels" type="button" class="rc-log__filter-btn"
              [class.rc-log__filter-btn--active]="isLogLevelActive(lvl)"
              [attr.data-level]="lvl"
              (click)="toggleLogLevel(lvl)">{{ lvl }}</button>
          </div>
          <ul class="rc-log__list">
            <li *ngFor="let m of filteredLogMessages()" class="rc-log__entry" [attr.data-level]="m.logLevel">
              <span class="rc-log__level" [attr.data-level]="m.logLevel">{{ m.logLevel }}</span>
              <span class="rc-log__msg">
                <ng-container *ngFor="let part of resolveGuids(m.content)">
                  <strong *ngIf="part.isGuid && part.isKnown" [title]="part.guid">{{ part.text }}</strong>
                  <span *ngIf="part.isGuid && !part.isKnown" class="rc-log__guid" [title]="part.guid">{{ part.text }}</span>
                  <ng-container *ngIf="!part.isGuid">{{ part.text }}</ng-container>
                </ng-container>
              </span>
            </li>
            <li class="rc-log__empty" *ngIf="!filteredLogMessages().length">No messages for the selected log levels.</li>
          </ul>
        </div>
      </div>
    </section>
  </main>
</div>
